import type { CheckDepthTier } from '@nestjs-boilerplate/types';

import { TIER_CONFIGS, TIER_ORDER } from '../constants/tier-config';

import { TierCard } from './tier-card';

interface CheckDepthSelectorProps {
  selectedTier: CheckDepthTier | null;
  onSelect: (tier: CheckDepthTier) => void;
}

/**
 * Container component rendering the 3 tier selection cards.
 * Displays Basic, Standard, and Enhanced tiers in a responsive grid.
 */
export function CheckDepthSelector({ selectedTier, onSelect }: CheckDepthSelectorProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Select due diligence level"
      className="grid grid-cols-1 gap-4 sm:grid-cols-3"
    >
      {TIER_ORDER.map((tierId) => (
        <TierCard
          key={tierId}
          tier={TIER_CONFIGS[tierId]}
          isSelected={selectedTier === tierId}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
